import React from 'react';
import classNames from 'classnames';
import Markdown from 'markdown-to-jsx';
import type { MarkdownToJSX } from 'markdown-to-jsx';

type Overrides = MarkdownToJSX.Overrides;

const DEFAULT_OVERRIDES: Overrides = {
  a: {
    props: {
      className: 'underline',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  },
  h1: { props: { className: 'font-semibold' } },
  h2: { props: { className: 'font-semibold' } },
  h3: { props: { className: 'font-semibold' } },
  h4: { props: { className: 'font-semibold' } },
  h5: { props: { className: 'font-semibold' } },
  h6: { props: { className: 'font-semibold' } },
  strong: { props: { className: 'font-semibold' } },
};

type OverrideEntryRecord = Record<
  string,
  { component?: unknown; props?: Record<string, unknown> }
>;

const mergeOverrides = (
  defaultOverrides: Overrides,
  customOverrides?: Overrides
): Overrides => {
  if (!customOverrides || Object.keys(customOverrides).length === 0) {
    return defaultOverrides;
  }

  const merged: OverrideEntryRecord = {
    ...(defaultOverrides as OverrideEntryRecord),
  };
  const custom = customOverrides as OverrideEntryRecord;

  for (const key of Object.keys(custom)) {
    const defaultEntry = merged[key] || {};
    const customEntry = custom[key] || {};

    merged[key] = {
      ...defaultEntry,
      ...customEntry,
      props: { ...defaultEntry.props, ...customEntry.props },
    };
  }

  return merged as Overrides;
};

interface MarkdownComponentProps {
  text?: string;
  customClass?: string;
  overrides?: Overrides;
}

const MarkdownComponent = ({
  text = '',
  customClass = 'markdown',
  overrides: customOverrides,
}: MarkdownComponentProps): React.JSX.Element => (
  <div className={classNames(customClass)}>
    <Markdown
      options={{
        wrapper: React.Fragment,
        overrides: mergeOverrides(DEFAULT_OVERRIDES, customOverrides),
      }}
    >
      {text}
    </Markdown>
  </div>
);

export default MarkdownComponent;
